import {
	showErrorNotification,
	showSuccessNotification,
} from "molecules/notifications/notificationEvents";
import { useState, useEffect } from "react";

import { useTranslation } from "react-i18next";
import { OAuthAuthorizationView } from "src/features/integrations/sources/oauth/OAuthAuthorizationView";

interface ExactOnlineAuthorizationModalProps {
	isOpen: boolean;
	onClose: () => void;
	title: string;
	description?: string;
	showModeSelection?: boolean;
	initialMode?: "redirect" | "copy";
	isLoading: boolean;
	onAuthorize: (mode: "redirect" | "copy") => Promise<string | null>;
}

export const ExactOnlineAuthorizationModal = ({
	isOpen,
	onClose,
	title,
	description,
	showModeSelection = false,
	initialMode = "redirect",
	isLoading,
	onAuthorize,
}: ExactOnlineAuthorizationModalProps) => {
	const { t } = useTranslation();
	const [mode, setMode] = useState<"redirect" | "copy">(initialMode);

	useEffect(() => {
		setMode(initialMode);
	}, [initialMode]);

	const handleSubmit = async () => {
		const authorizationUrl = await onAuthorize(mode);
		if (!authorizationUrl) return;

		if (mode === "redirect") {
			location.href = authorizationUrl;
		} else {
			try {
				await navigator.clipboard.writeText(authorizationUrl);
				showSuccessNotification({
					message: t("The link was copied to clipboard"),
				});
				onClose();
			} catch {
				showErrorNotification({
					message: t("Failed to copy authentication link"),
				});
			}
		}
	};

	return (
		<OAuthAuthorizationView
			isOpen={isOpen}
			onClose={onClose}
			title={title}
			description={description}
			providerName="Exact Online"
			showModeSelection={showModeSelection}
			mode={mode}
			onModeChange={setMode}
			isLoading={isLoading}
			onSubmit={handleSubmit}
		/>
	);
};
